import { PanelCards } from '../../../Panel';
import { FHA, WEATHER } from '../../../../constants/cards';
import { PlantingCard } from '../../../cards/PlantingCard';

const CARDS = [WEATHER, FHA];

export interface PlantingPanelProps {
  index: number;
  isCollapsed?: boolean;
}

function PlantingPanel({ index, isCollapsed }: PlantingPanelProps) {
  const firstCard = <PlantingCard index={index} />

  return (
    <PanelCards
      cards={CARDS}
      firstCard={firstCard}
      index={index}
      isCollapsed={isCollapsed}
      testId="planting"
    />
  );
}

export default PlantingPanel;
